import React, { useMemo } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Col, Row } from "react-bootstrap";

import { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import NextIcon from "./assets/next.svg";
import PrevIcon from "./assets/prev.svg";
import Link from "next/link";

import styles from "./styles/style.module.scss";
import { FormattedMessage } from "react-intl";
import { buildWhatsAppUrl } from "../../../utils/whatsapp.mjs";
const Hero = ({ heroData, siteInfo }) => {
  const { locale } = useRouter();
  const dir = useMemo(() => (locale === "en" ? "ltr" : "rtl"), [locale]);

  return (
    <div className={styles.hero}>
      <div className="swiper-button-next">
        <Image src={PrevIcon} width={50} height={50} alt="prev-icon" />
      </div>
      <div className="swiper-button-prev">
        <Image src={NextIcon} width={50} height={50} alt="next-icon" />
      </div>
      <Swiper
        slidesPerView={1}
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        dir={dir}
        key={dir}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        pagination={{
          clickable: true,
        }}
      >
        {heroData?.items?.map((item, index) => (
          <SwiperSlide key={index}>
            <div
              className="hero"
              style={{
                paddingInline: "35px",
              }}
            >
              <div className="slider">
                <div className="hero-slider">
                  <div
                    className="col-lg-10 col-12 text-start wrapper w-100"
                    style={{
                      direction: locale === "ar" ? "rtl" : "ltr",
                    }}
                  >
                    <div className="h-item">
                      <Row>
                        <Col md="6" className="h-item-div">
                          <h2 className="h1">
                            {item?.heading?.[locale]}
                            <br />
                            <strong>{item?.boldHeading?.[locale]}</strong>
                          </h2>
                          <p>{item?.description?.[locale]}</p>
                          <div className="d-flex align-items-center gap-3">
                            <Link
                              href="/personnel"
                              passHref
                              className="gradient-btn"
                            >
                              <FormattedMessage id="recruitmentRequest" />
                            </Link>
                            <Link
                              href={buildWhatsAppUrl(siteInfo?.whatsup)}
                              passHref
                              className="gradient-btn"
                              target="_blank"
                            >
                              <FormattedMessage id="transferMaidsRequest" />
                            </Link>
                          </div>
                        </Col>
                        <Col md="6">
                          <Row className="hero-secondary-wrapper">
                            <Col className="hero-secondary">
                              <Image
                                loading={index === 0 ? "eager" : "lazy"}
                                priority={index === 0}
                                src={item?.image}
                                width={600}
                                height={600}
                                style={{
                                  minHeight: "150px",
                                }}
                                alt="Hero image"
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Hero;
